import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import About from "@/components/About";
import Contact from "@/components/Contact";
import Gallery from "@/components/Gallery";
import Hero from "@/components/Hero";
import SEO from "@/components/SEO";
import Services from "@/components/Services";
import Testimonials from "@/components/Testimonials";
import TikTokShowcase from "@/components/TikTokShowcase";
import type { AutoRepairSchema } from "@/types";

const Home: React.FC = () => {
	const location = useLocation();

	useEffect(() => {
		// Scroll zu Section wenn Hash vorhanden (z.B. /#about)
		if (location.hash) {
			const targetId = location.hash.replace("#", "");
			
			// Längere Verzögerung um sicherzustellen, dass die Seite geladen ist
			const timer = setTimeout(() => {
				const element = document.getElementById(targetId);
				if (element) {
					const navHeight = 84; // Navbar height offset
					const elementPosition = element.getBoundingClientRect().top;
					const offsetPosition = elementPosition + window.pageYOffset - navHeight;

					window.scrollTo({
						top: offsetPosition,
						behavior: "smooth"
					});
				}
			}, 300);

			return () => clearTimeout(timer);
		}
	}, [location.hash]);

	const schema: AutoRepairSchema = {
		"@context": "https://schema.org",
		"@type": "AutoRepair",
		name: "WILDFÖRSTER Fahrzeugaufbereitung",
		description:
			"Professionelle Fahrzeugaufbereitung in Wuppertal. Autopflege, Lackversiegelung, Innenraumreinigung und mehr.",
		url: "https://aufbereitung-wuppertal.de",
		telephone: "+49-170-3571907",
		email: "daniel.wildfoerster@gmail.com",
		address: {
			"@type": "PostalAddress",
			streetAddress: "Große Haken Straße 42",
			addressLocality: "Wuppertal",
			postalCode: "42283",
			addressCountry: "DE",
		},
		geo: {
			"@type": "GeoCoordinates",
			latitude: 51.2562,
			longitude: 7.1508,
		},
		areaServed: {
			"@type": "City",
			name: "Wuppertal",
		},
		serviceType: [
			"Fahrzeugaufbereitung",
			"Autopflege",
			"Lackversiegelung",
			"Keramikversiegelung",
			"Innenraumreinigung",
			"Polsterreinigung",
		],
		priceRange: "€€",
		openingHoursSpecification: [
			{
				"@type": "OpeningHoursSpecification",
				dayOfWeek: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
				opens: "09:00",
				closes: "18:00",
			},
			{
				"@type": "OpeningHoursSpecification",
				dayOfWeek: "Saturday",
				opens: "10:00",
				closes: "14:00",
			},
		],
		sameAs: [
			"https://m.facebook.com/Daniel-Wildf%C3%B6rster-113290246971839/",
			"https://www.instagram.com/wildforsterdaniel/",
			"https://www.tiktok.com/@wildfoerster13",
		],
	};

	return (
		<>
			<SEO schema={schema} />
			<main>
				<Hero />
				<About />
				<Services />
				<Testimonials />
				<TikTokShowcase />
				<Gallery />
				<Contact />
			</main>
		</>
	);
};

export default Home;
